<template>
  <md-toolbar
    md-elevation="0"
    class="md-transparent top-nav"
    :class="{
      'md-toolbar-absolute md-white md-fixed-top': $route.meta.navbarAbsolute,
    }"
  >
    <div class="md-toolbar-row">
      <div class="md-toolbar-section-start">
        <h3 class="md-title">{{ pageTitle || $route.title || $route.name }}</h3>
        <md-progress-spinner
          slot="route-title"
          :md-diameter="20"
          :md-stroke="3"
          md-mode="indeterminate"
          v-show="contentLoading > 0"
        />
      </div>
      <div class="md-toolbar-section-end">
        <md-button
          class="md-just-icon md-round md-simple md-toolbar-toggle"
          :class="{ toggled: $sidebar.showSidebar }"
          @click="toggleSidebar"
        >
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
        </md-button>

        <div class="md-collapse md-layout">
          <div class="md-layout-item md-size-50">
            <sinister-select
              @input="goToSinisterFile($event.roadsId)"
              :fetch-options="{
                isExtranet,
              }"
            />
          </div>

          <md-list>
            <li class="md-list-item">

            </li>
            <li class="md-list-item">
              <a
                class="md-list-item-router md-list-item-container md-button-clean dropdown"
              >
                <div class="md-list-item-content">
                  <drop-down direction="down">
                    <md-button
                      slot="title"
                      class="md-button md-just-icon md-simple"
                      data-toggle="dropdown"
                    >
                      <div id="example-2">
                        <transition name="bounce">
                          <md-icon class="alert-icon" v-if="showAnimation"
                            >notifications_active</md-icon
                          >
                        </transition>
                        <transition name="noti">
                          <md-icon class="alert-icon" v-if="!showAnimation"
                            >notifications</md-icon
                          >
                        </transition>
                      </div>
                      <span class="notification">{{ alerts.length }}</span>
                      <p class="hidden-lg hidden-md">Notifications</p>
                    </md-button>
                    <md-list class="dropdown-menu dropdown-menu-right">
                      <md-content>
                        <md-list-item v-if="alerts.length == 0">
                          <md-card md-with-hover>
                            <div class="md-list-item-text">
                              <div class="md-title">
                                No hay notificaciones nuevas
                              </div>
                            </div>
                          </md-card>
                        </md-list-item>
                        <md-list-item
                          class="md-layout-item md-size-100"
                          v-for="alert in alerts"
                          v-bind:key="alert.id"
                        >
                          <md-card md-with-hover>
                            <div class="md-layout">
                              <div
                                class="md-list-item-text"
                                @click="showAlert(alert)"
                              >
                                <div class="md-title noti-title">
                                  {{ alert.verb }}
                                </div>
                                <p v-html="alert.description" />
                                <md-tooltip md-direction="left">
                                  <strong>{{ alert.from_date }}</strong>
                                  <p v-html="alert.description" />
                                </md-tooltip>
                              </div>
                              <md-card-actions>
                                <md-button
                                  @click="removeAlert(alert)"
                                  class="md-simple md-just-icon"
                                  md-with-hover
                                >
                                  <md-icon>notifications_off</md-icon>
                                </md-button>
                              </md-card-actions>
                            </div>
                          </md-card>
                        </md-list-item>
                      </md-content>
                    </md-list>
                  </drop-down>
                </div>
              </a>
            </li>

            <md-list-item :to="{ name: 'Perfil de usuario' }">
              <i class="material-icons">person</i>
              <p class="hidden-lg hidden-md">Profile</p>
            </md-list-item>
          </md-list>
        </div>
      </div>
    </div>
  </md-toolbar>
</template>

<script>
import { SinisterSelect } from "@/components";
import { mapState, mapGetters } from "vuex";
import notificationService from "../../../services/notification";

export default {
  components: {
    SinisterSelect,
  },
  data() {
    return {
      selectedEmployee: "",
      showAnimation: true,
      newNoti: true,
      employees: [
        "Jim Halpert",
        "Dwight Schrute",
        "Michael Scott",
        "Pam Beesly",
        "Angela Martin",
        "Kelly Kapoor",
        "Ryan Howard",
        "Kevin Malone",
      ],
    };
  },
  computed: {
    ...mapState("alerts", {
      alerts: (s) => s.alerts,
    }),
    ...mapGetters({
      contentLoading: "app/contentLoading",
      pageTitle: "app/pageTitle",
    }),
    isExtranet() {
      return [
        "Extranet",
        "Extranet_GeRe",
        "Extranet_JeAd",
        "Extranet_JeEl",
        "Extranet_JeCo",
      ].some((g) => this.$inGroup(g));
    },
  },
  methods: {
    newNotification() {
      if (this.newNoti) {
        this.showAnimation = true;
        setTimeout(this.hideNotifications, 1490);
      }
    },
    hideNotifications() {
      this.showAnimation = false;
    },
    activateAnimation() {
      this.newNoti = true;
    },
    goToSinisterFile(id) {
      if (!id) {
        this.$notify({
          message: "No se puede acceder al siniestro porque es inválido.",
          icon: "close",
          horizontalAlign: "center",
          verticalAlign: "bottom",
          type: "danger",
        });
        return;
      }
      const routeName = !this.isExtranet
        ? "Ficha de Siniestro Carretero"
        : "Ficha de Siniestro Carretero Cliente";
      const routeData = this.$router.resolve({
        name: routeName,
        params: {
          id,
        },
      });

      window.open(routeData.href, "_blank");
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    removeAlert(alert) {
      this.newNoti = false;
      setTimeout(this.activateAnimation, 100);
      notificationService.readNotificaion(alert);
    },
    showAlert(alert) {
      let content = "<h5>" + alert.description + "</h5>";
      if (alert.type == "sinister") {
        content =
          content +
          ("<li><h6>" +
            alert.sinister.sinister_number +
            "</h6></li>" +
            "<li><h6>Requisición: " +
            alert.sinister.requisition_number +
            "</h6></li>" +
            "<li><h6>Folio JB: " +
            alert.sinister.folio_jb +
            "</h6></li>" +
            "</ul>");
        this.$fire({
          title: "<strong>" + alert.verb + "</strong>",
          icon: alert.level,
          html: content,
          showDenyButton: true,
          showCloseButton: true,
          confirmButtonText: "Ficha de Siniestro",
          denyButtonText: `Marcar alerta como leida`,
        }).then((result) => {
          if (result.isConfirmed) {
            this.goToSinisterFile(alert.sinister.road_sinister_id);
          } else if (result.isDenied) {
            this.removeAlert(alert);
          }
        });
      } else if (alert.type == "sinisters") {
        content = content + "<h5>Datos de los Siniestros:</h5>";
        alert.sinisters.forEach((sinister) => {
          content =
            content +
            ("<ul>" +
              "<li>" +
              sinister.sinister_number +
              "</li>" +
              "<li>Requisición: " +
              sinister.requisition_number +
              "</li>" +
              "<li>Folio JB: " +
              sinister.folio_jb +
              "</li>" +
              "</ul>");
        });
        this.$fire({
          title: "<strong>" + alert.verb + "</strong>",
          icon: alert.level,
          html: content,
          showDenyButton: true,
          showCloseButton: true,
          denyButtonText: `Marcar alerta como leida`,
        }).then((result) => {
          if (result.isDenied) {
            this.removeAlert(alert);
          }
        });
      } else if (alert.type == "custom") {
        content = content + alert.content;
        this.$fire({
          title: "<strong>" + alert.verb + "</strong>",
          icon: alert.level,
          html: content,
          showDenyButton: true,
          showCloseButton: true,
          denyButtonText: `Marcar alerta como leida`,
        }).then((result) => {
          if (result.isDenied) {
            this.removeAlert(alert);
          }
        });
      } else {
        this.$fire({
          title: "<strong>" + alert.verb + "</strong>",
          icon: alert.level,
          html: content,
          showConfirmButton: false,
          showDenyButton: true,
          showCloseButton: true,
          denyButtonText: `Marcar alerta como leida`,
        }).then((result) => {
          if (result.isDenied) {
            this.removeAlert(alert);
          }
        });
      }
    },
    minimizeSidebar() {
      if (this.$sidebar) {
        this.$sidebar.toggleMinimize();
      }
    },
  },
  watch: {
    deep: true,
    alerts: function () {
      this.newNotification();
    },
  },
};
</script>

<style lang="scss" scoped>
.top-nav {
  z-index: 20;
}
.notification {
  margin-top: 2px;
}
.md-card {
  margin: 2px !important;
}
.md-list-item-text {
  padding: 5px !important;
}
.bounce-enter-active {
  animation: bounce-in 1.5s;
}
.bounce-leave-active {
  animation: bounce-out 0.5s;
}
.noti-enter-active {
  animation: noti-in 1.5s;
}
.noti-leave-active {
  animation: noti-out 0.5s;
}

.md-title.noti-title {
  font-size: 15px;
  font-weight: bold;
}

@keyframes noti-in {
  0% {
    transform: scale(1);
    position: relative;
  }
  100% {
    transform: scale(1);
    position: relative;
  }
}
@keyframes noti-out {
  0% {
    transform: scale(0);
    position: absolute;
  }
  100% {
    transform: scale(0);
    position: absolute;
  }
}
@keyframes bounce-in {
  0% {
    transform: scale(1);
    position: relative;
  }
  10% {
    transform: scale(2);
  }
  20% {
    transform: scale(1);
  }
  30% {
    transform: scale(2);
  }
  40% {
    transform: scale(1);
  }
  50% {
    transform: scale(2);
  }
  60% {
    transform: scale(1);
  }
  70% {
    transform: scale(2);
  }
  80% {
    transform: scale(1);
  }
  90% {
    transform: scale(2);
  }
  100% {
    transform: scale(1);
    position: relative;
  }
}
@keyframes bounce-out {
  0% {
    transform: scale(0);
    position: absolute;
  }
  100% {
    transform: scale(0);
    position: absolute;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Dashboard/Layout/TopNavbar.vue